import { takeEvery, put } from 'redux-saga/effects'
import { replace } from 'react-router-redux'
import * as route from '../routes'
import { GO_BACK } from '../actions'

function* watchForLocationChange() {
  yield takeEvery('@@router/LOCATION_CHANGE', function* x({ payload }) {
    if (payload.action === 'POP' && /campaigns\/\d+\/missions\/\d+/.exec(payload.pathname)) {
      const ids = /\d+/.exec(payload.pathname)
      yield put(replace(route.campaign_path({ id: ids[0] })))
    }
  })
}

const getUrlIds = (url, ids = []) => {
  const match_id = /\d+/.exec(url)
  if (match_id && match_id.length > 0) {
    const id = match_id[0]
    return getUrlIds(url.replace(id, ':id'), ids.concat(id))
  }
  // TODO: REFACTOR NOT_FOUND
  const match_not_found = /user_not_found/.exec(url)
  if (match_not_found && match_not_found.length > 0) {
    return { url: '/user_not_found/:email', ids }
  }
  return { url, ids }
}

function* watchForGoBack() {
  yield takeEvery(GO_BACK, function* x({ payload: { from } }) {
    const { url, ids } = getUrlIds(from)
    yield put(replace(route.back_path(url, ids)))
  })
}

export default [watchForLocationChange, watchForGoBack]



// WEBPACK FOOTER //
// ./src/sagas/router.jsx